import { SharedProjectionsPharmacyGeneralViewSchema } from '@libs/shared/domain/projections/shared-projections-pharmacy-general-view.schema';

export interface PharmacyViewModel extends SharedProjectionsPharmacyGeneralViewSchema {
  address?: string;
  blockReason?: string;
  brightDay?: string;
}

export const PHARMACY_SIMPLE_VIEW_MODEL_KEYS = [
  'name',
  'ncpdp',
  'npi',
  'contactEmail',
  'contactPersonEmail',
  'addressCity',
  'addressState',
] as const;

export type PharmacySimpleViewModel = Pick<SharedProjectionsPharmacyGeneralViewSchema, (typeof PHARMACY_SIMPLE_VIEW_MODEL_KEYS)[number]>;
